<template>
  <div class="introduce-right">
    <div class="introright-top live-icon">
      <div class="live-introde">
        <i class="iconfont living-management">&#xe60e;</i>&ensp;{{
          isHome
            ? $t("livingRank.gold_anchor")
            : $t("livingRank.anchor_recommend")
        }}
      </div>
      <div class="live-introde-right" @click="liveRank(false)" v-if="!isHome">
        {{ $t("livingRank.change_batch") }}
        <i class="iconfont update-icon" :class="{ loading: isLoading }"
          >&#xe62c;</i
        >
      </div>
    </div>
    <div class="introright-bottom">
      <template v-if="!orderData.length && !orderData.loaded">
        <div
          class="rank-list"
          v-for="(item, index) in new Array(3)"
          :key="index"
        >
          <Skeleton />
        </div>
      </template>
      <router-link
        target="_blank"
        :to="'/liveDetails/' + item.id + '-' + item.stream"
        class="rank-list"
        v-for="(item, index) in orderData"
        :key="item.id"
      >
        <div class="rank-left">
          <div class="rank-first" v-show="isHome">{{ index + 1 }}</div>
          <div class="rank-logo">
            <img v-lazy="item.avatar_thumb" alt="logo" />
          </div>
          <div class="rank-words">
            <div class="rankwords-top">{{ item.user_nicename }}</div>
            <div class="rankwords-bottom">
              <i class="iconfont look-time">&#xe607;</i>{{ item.viewnum }}
            </div>
          </div>
        </div>
        <div
          class="rank-right"
          :class="{ 'is-sub': item.isSubscribe }"
          @click.prevent="subscribeAnchor(item)"
        >
          {{
            item.isSubscribe
              ? $t("livingRank.subscribed")
              : $t("livingRank.subscribe")
          }}
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
import { apiSubscribeAnchor, apiGetRecommendAnchor } from "../http";
export default {
  name: "livingRank",
  props: ["isHome"],
  data() {
    return {
      isLoading: false,
      orderData: [],
      isLogin: localStorage.getItem("uid"),
    };
  },
  mounted() {
    this.liveRank(true);
  },
  methods: {
    liveRank(init) {
      if (this.isLoading) return;
      if (!init) this.isLoading = true;
      let params = { limit: 6 };
      if (this.isHome) params.order = 1;
      apiGetRecommendAnchor(params)
        .then((res) => {
          this.orderData = res.info;
          this.orderData.loaded = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    subscribeAnchor(item) {
      if (!localStorage.getItem("uid")) {
        this.$EventBus.$emit("loginShow");
        return;
      }
      let type = item.isSubscribe ? 2 : 1;
      apiSubscribeAnchor({ touid: item.id, type: type }).then((res) => {
        item.isSubscribe = !item.isSubscribe;
        this.$EventBus.$emit("hide", res.msg);
      });
    },
  },
};
</script>
<style scoped>
.introduce-right {
  width: 30rem;
  display: flex;
  flex-direction: column;
}
.introright-bottom {
  background: #fff;
  margin-top: 1.7rem;
  flex: 1;
}
.rank-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 0;
  cursor: pointer;
  color: #2b2626;
}
.rank-left {
  display: flex;
  align-items: center;
}
.rank-first {
  width: 2.1rem;
  height: 2.1rem;
  /* background:url('./../assets/img/ranking.png') no-repeat center center; */
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
  text-align: center;
  line-height: 2.1rem;
  font-weight: bold;
  font-weight: bold;
  color: #666;
}
.rank-list:nth-child(1) .rank-first,
.rank-list:nth-child(2) .rank-first,
.rank-list:nth-child(3) .rank-first {
  background-image: var(--img-rank);
  color: #fff;
}

.rank-logo {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 0.5rem;
}
.rank-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.rank-words {
  max-width: 9rem;
}
.rankwords-top {
  font-size: 1.4rem;
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.rankwords-bottom {
  color: #9f9f9f;
  margin-top: 1.3rem;
}
.rank-right {
  min-width: 5rem;
  height: 2.2rem;
  border-radius: 1.1rem;
  border: 1px solid #eaeaea;
  text-align: center;
  line-height: 2.2rem;
  margin-right: 1.1rem;
  cursor: pointer;
  user-select: none;
  padding: 0 0.8rem;
}
.rank-right:hover {
  border-color: var(--primary-color);
  color: var(--primary-color);
}
.rank-right.is-sub {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  color: #fff;
}
.live-icon {
  font-size: 2.4rem;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.live-introde-right {
  font-size: 1.2rem;
  color: #949292;
  font-weight: normal;
  cursor: pointer;
}
.update-icon {
  font-size: 1.2rem;
}
.living-icon,
.living-management {
  color: var(--primary-color);
  font-size: 3rem;
}
img {
  background: #eaeaea;
}
.live-introde-right {
  position: relative;
  padding-right: 2rem;
}
.live-introde-right .iconfont {
  position: absolute;
  right: 0;
}
.live-introde-right .loading {
  animation: loading 0.8s infinite;
}
@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/base/livingRank.vue